import wechat from 'weixin-js-sdk'
import { sendMessageAndInsert } from '@/utils/message_send'
import { MESSAGE_NAME, STATUS } from '@/constants/message'
import { SET_MESSAGE_VALUE_BY_ID } from '@/constants/pub_sub'

export default {
    methods: {
        translateWechatAudio () {
            wechat.translateVoice({
                localId: this.localId, // 需要识别的音频的本地Id，由录音相关接口获得
                isShowProgressTips: 1, // 默认为1，显示进度提示
                success: ({ translateResult }) => {
                    setMessageStatusById.call(this, this.messageId, STATUS.SUCCESS)
                    this.appendAudioTranslationMessage(translateResult)
                },
                fail: (err) => {
                    // eslint-disable-next-line
                    console.error(err)
                    setMessageStatusById.call(this, this.messageId, STATUS.FAIL)
                }
            })

            function setMessageStatusById (messageId, status) {
                this.$eventBus.$emit(SET_MESSAGE_VALUE_BY_ID, {
                    id: messageId,
                    path: 'baseProps.status',
                    value: status
                })
            }
        },
        appendAudioTranslationMessage (text) {
            sendMessageAndInsert({
                type: 'base',
                detailType: MESSAGE_NAME.AUDIO_TRANSLATION,
                content: text
            }, this.messageId)
        }
    },
    created () {
        if (this.localId) {
            this.translateWechatAudio()
        }
    }
}
